import React from 'react';
import { format, parseISO } from 'date-fns';
import {
  BarChart,
  Bar,
  XAxis,
  YAxis,
  CartesianGrid,
  Tooltip,
  ResponsiveContainer
} from 'recharts';

const ConsumptionBarChart = ({ title ,color ,type ,prepareBarChartData }) => {
  
  const CustomTooltip = ({ active, payload, label, title, color }) => {
    if (!active || !payload || !payload.length || 
      !payload.some(p => p.value > 0)) {
      return null;
    }
    if (active && payload && payload.length) {
      return (
        <div style={{ 
          backgroundColor: '#fff',
          border: '1px solid #ccc',
          borderRadius: '4px',
          padding: '8px',
          zIndex: 9999 ,
          position: 'relative',
          boxShadow: '0 2px 4px rgba(0,0,0,0.1)'
        }}>
          <div style={{ marginBottom: '4px', fontSize: '11px', color: '#666' }}>
            {format(new Date(label), 'MMM dd yyyy')}
          </div>
          <div style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
            <div style={{ 
              width: '12px', 
              height: '12px', 
              backgroundColor: color,
              borderRadius: '2px'
            }} />
            <span>{title}: {payload[0].value}</span>
          </div>
        </div>
      );
    }
    return null;
  };
  

  const chartData = prepareBarChartData(type);

  return (
    
    <ResponsiveContainer width="100%" height={300}>
      <BarChart
        data={chartData}
        margin={{
          top: 30,
          right: 0,
          bottom: 0,
          left: 2,
        }}
        barCategoryGap="5%"
        barGap={2}
      >
        <CartesianGrid 
          strokeDasharray="0 0"
          horizontal={true}
          vertical={false}  
        />
        <XAxis 
          dataKey="date"
          angle={0}
          height={60}
          interval={0}
          axisLine={false}
          tickLine={false} 
          tickFormatter={(value) => {
              const firstDate = chartData[0] && chartData[0].date;
              const lastDate = chartData[chartData.length - 1] && chartData[chartData.length - 1].date;
              const dateObj = typeof value === 'string' ? parseISO(value) : new Date(value);
              if (value === firstDate || value === lastDate) {
              return format(dateObj, 'MMM d');
              }
              return "";
          }}

          tick={{ 
            fontSize: 9
          }}
        />
        <YAxis 
          axisLine={false}
          tickLine={false}
          tick={{ 
            fontSize: 9,
            fill: '#666'
          }}
        />
        <Tooltip 
          cursor={false}
          content={<CustomTooltip title={title} color={color} />}
        />
        <Bar 
          dataKey="value" 
          fill={color} 
          barSize={20}
        />
      </BarChart>
    </ResponsiveContainer>
  );
};

export default ConsumptionBarChart;